import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import { getPrimaryColor } from '../../utils';

const Loader = ({
  style,
  className,
  setting = 'main',
  size = 48,
  ...props
}) => (
  <div className={className || 'w3-center w3-padding'}>
    <span
      style={{
        style,
        borderTop: `6px solid ${getPrimaryColor(props, setting)}`,
        width: `${size}px`,
        height: `${size}px`,
      }}
      className="s7t-loader w3-show-inline-block"
    />
  </div>
);

export default withTheme(Loader);
